function openMenu() {
  if ( document.querySelector(".slide-nav__overflow.slide-nav__overflow--thumb").classList.contains("js-menu--is-open") === true ){
    document.querySelector(".croix-menu svg").innerHTML = '<rect y="1" width="20" height="1" fill="black"/><rect y="9" width="20" height="1" fill="black"/><rect y="17" width="20" height="1" fill="black"/>';
    document.querySelector(".slide-nav__overflow.slide-nav__overflow--thumb").classList.remove("js-menu--is-open");
    document.querySelector("header.site-header").classList.remove("is-open");
  }else{
    document.querySelector(".croix-menu svg").innerHTML = '<g clip-path="url(#clip0_2650_18)"><rect x="0.863281" width="26.8487" height="1" transform="rotate(45 0.863281 0)" fill="black"/><rect x="19.8477" y="0.707031" width="26.8487" height="1" transform="rotate(135 19.8477 0.707031)" fill="black"/></g><defs><clipPath id="clip0_2650_18"><rect width="20" height="20" fill="white"/></clipPath></defs>';
    document.querySelector(".slide-nav__overflow.slide-nav__overflow--thumb").classList.add("js-menu--is-open");
    document.querySelector("header.site-header").classList.add("is-open");
  }
};

var width_screen = window.innerWidth;
if (width_screen < 768) {
  var imagesProduits = document.querySelectorAll('.product__photos .flickity-slider img');
  for (var i = 0; i < imagesProduits.length; i++) {
    imagesProduits[i].addEventListener('click', function(event) {
      const dots = document.querySelectorAll('.flickity-page-dots .dot');
      let currentIndex = -1;
      dots.forEach((dot, index) => {
          if (dot.classList.contains('is-selected')) {
              currentIndex = index;
          }
      });
      let nextIndex = (currentIndex + 1) % dots.length;
      dots[nextIndex].click();
    });
  }
}


if (!!document.querySelector(".sticky-add-to-cart .btn") === true){
  document.querySelector(".sticky-add-to-cart .btn").onclick = function() {
    document.querySelector('button.add-to-cart[type="submit"]').click();
  };
}

window.addEventListener("load", (event) => {
  if (!!document.querySelector(".btn.klaviyo-bis-trigger") === true){
    var textBtn = document.querySelector(".product-single__form .btn.add-to-cart").textContent;
    if ( textBtn.includes("rupture") ){
      document.querySelector('.sticky-add-to-cart .rupture').style.cssText = "display: block !important;";
    }else{
      document.querySelector('.sticky-add-to-cart .rupture').style.cssText = "none: block !important;";
    }
    document.querySelector(".sticky-add-to-cart .rupture").onclick = function() {
      document.querySelector('.btn.klaviyo-bis-trigger').click();
    };
  }
});